module.exports = __webpack_public_path__ + "static/media/auth_service_google.70f0d980.svg";